import React from 'react';

const AdminLogin = () => (
  <div className="flex-center" style={{ minHeight: '100vh' }}>
    <div style={{ maxWidth: '400px', width: '100%', padding: '2rem', background: 'var(--bg-secondary)', borderRadius: 'var(--radius-lg)' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '2rem' }}>Admin Login</h1>
      <p style={{ textAlign: 'center', color: 'var(--text-secondary)' }}>Login form implementation needed</p>
    </div>
  </div>
);

export default AdminLogin;
